import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

export const setAuthToken = (token) => {
  if (token) api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  else delete api.defaults.headers.common["Authorization"];
};

const stored = localStorage.getItem("msis_admin_token");
if (stored) setAuthToken(stored);

export const DOMAIN_COLORS = {
  FIN: "#0F766E",
  MKT: "#DC2626",
  HRM: "#EA580C",
  OSCM: "#7C3AED",
  ADB: "#002FA7",
  SC: "#0EA5E9",
  IE: "#D97706",
  IB: "#16A34A",
  SRM: "#16A085",
};

export const LIKERT = [
  { value: 1, label: "Strongly Disagree" },
  { value: 2, label: "Disagree" },
  { value: 3, label: "Neutral / Not Sure" },
  { value: 4, label: "Agree" },
  { value: 5, label: "Strongly Agree" },
];

export const loadRazorpay = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
